import styled from "styled-components";

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 16px;
  background: #fff;
  overflow-y: auto;
`;


export const MessageList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const InputWrapper = styled.form`
  display: flex;
  padding: 12px;
  border-top: 1px solid #ddd;
  background: #fafafa;
`;

export const TextInput = styled.textarea`
  flex: 1;
  resize: none;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 1rem;
  max-height: 120px;

  &:focus {
    outline: none;
    border-color: #2196f3;
  }
`;

export const SendButton = styled.button`
  margin-left: 8px;
  padding: 0 16px;
  background: #2196f3;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: bold;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;